export function generateOptions(
    length: number
): Array<{ value: string; label: number }> {
    return Array.from({ length }, (_, i) => {
        const label = i + 1;
        const value = `${label.toString().padStart(2, '0')}:00:00`;
        return { value, label };
    });
}

export const formatPeriod = (hours: number): string => {
    const h = String(hours).padStart(2, '0');
    const m = '00';
    const s = '00';
    return `${h}:${m}:${s}`;
};
